import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';

import MarvelLink from '@marvelapp/marvel-ui/link';
import Paragraph from '@marvelapp/marvel-ui/paragraph';
import Spacing from '@marvelapp/marvel-ui/spacing';

import Image from 'marketing-website/components/modules/Image';
import styles from './style/general.module.css';

export default function CustomerStory({ url, image, title, logo }) {
  return (
    <div>
      {url ? (
        <div className={styles.hover}>
          <Link to={url}>
            <MarvelLink type="light">
              <Spacing size="m" position="bottom" type="margin">
                <div className={styles.imageHover}>
                  <Image {...image} maxWidth="100%" hasShadow={false} />
                </div>
              </Spacing>
              <Spacing size="m" position="bottom" type="margin">
                <Paragraph tag="div" size="l">
                  {title}
                </Paragraph>
              </Spacing>
              {logo}
            </MarvelLink>
          </Link>
        </div>
      ) : (
        <div>
          <Spacing size="m" position="bottom" type="margin">
            <Image {...image} maxWidth="100%" hasShadow={false} />
          </Spacing>
          <Spacing size="m" position="bottom" type="margin">
            <Paragraph tag="div" size="l">
              {title}
            </Paragraph>
          </Spacing>
          {logo}
        </div>
      )}
    </div>
  );
}

CustomerStory.propTypes = {
  url: PropTypes.string,
  image: PropTypes.object,
  title: PropTypes.string,
  logo: PropTypes.node,
};



// WEBPACK FOOTER //
// ./src/components/modules/CustomerStory/index.js